import React from 'react';
import TopBar from './TopBar';
import { Content, ContentContainer, Root, Wrapper } from './style';

const Layout = ({ topBarProps, children, ...rest }) => {
  return (
    <Root {...rest}>
      <TopBar backLink={topBarProps.backLink} forwardLink={topBarProps.forwardLink} text={topBarProps.text} fileLink={topBarProps.fileLink}/>
      <Wrapper>
        <ContentContainer>
          <Content>{children}</Content>
        </ContentContainer>
      </Wrapper>
    </Root>
  );
};

export default Layout;
